import React from 'react';
import './gallery.scss';
import { Col, Container, Row } from 'react-bootstrap';
import Slider from 'react-slick';

function Gallery() {
  const [selectedImage, setSelectedImage] = React.useState(null);

  const images = require.context(
      './images',
      false,
      /\.(jpg|jpe?g|png|webp|avif)$/i
  );

  const galleryImages = images.keys().map(images);

  const settings = {
    className: 'center',
    centerMode: true,
    infinite: true,
    centerPadding: '50px',
    focusOnSelect: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 500,
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1
        }
      }
    ]
  };

  React.useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setSelectedImage(null);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <div id="gallery" className="pt70">
      <div className="gallery pt50 mb100">
        <Container>
          <Row>
            <Col md={12}>
              <div className="section-title">Gallery</div>
            </Col>
          </Row>
        </Container>

        <Container fluid className="gallery-wrapper">
          <Row>
            <Col md={12}>
              <Slider {...settings}>
                {galleryImages.map((src, index) => (
                    <div key={src}>
                      <img
                          className="img1"
                          src={src}
                          alt={`Glamping gallery ${index + 1}`}
                          loading="lazy"
                          onClick={() => setSelectedImage(src)}
                          style={{ cursor: 'zoom-in' }}
                      />
                    </div>
                ))}
              </Slider>
            </Col>
          </Row>
        </Container>
      </div>

      {selectedImage && (
        <div
          className="gallery-lightbox"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="gallery-lightbox-close"
            onClick={() => setSelectedImage(null)}
            aria-label="Close image"
          >
            &times;
          </button>

          <img
            src={selectedImage}
            alt="Glamping gallery enlarged"
            onClick={(event) => event.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}

export default Gallery;